module.exports = __webpack_public_path__ + "build/static/media/login-bg.231e3688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg.jpg
// module id = 276
// module chunks = 6